// frontend/src/features/livestock/AddPhotosButton.tsx
import type { ReactNode } from 'react';
import { FileButton } from '@mantine/core';
import type { UploadAssignTo } from './photoUploadQueue';
import { useAddPhotosPicker } from './useAddPhotosPicker';

export interface AddPhotosButtonProps {
  /** Renders the button; spread the props onto it so a click opens the picker. */
  children: (props: { onClick: () => void }) => ReactNode;
  /** On the inbox grid: a single photo opens with Back returning to the grid. */
  fromInbox?: boolean;
  /** 'tank': the photos go straight to Tank Shots (the Tank Shots page). */
  assignTo?: UploadAssignTo;
}

/**
 * Opens the photo library and sends the picked photos to the selected tank's
 * inbox, or with assignTo 'tank' straight to its Tank Shots.
 */
export function AddPhotosButton({
  children,
  fromInbox,
  assignTo,
}: AddPhotosButtonProps): JSX.Element {
  const { onPick, resetRef } = useAddPhotosPicker({ fromInbox, assignTo });
  return (
    // accept must stay exactly image/*: iOS converts HEIC to JPEG on pick only then.
    <FileButton onChange={onPick} accept="image/*" multiple resetRef={resetRef}>
      {children}
    </FileButton>
  );
}
